import { memberZoneApi } from 'api';
import { MemberCodeOutput } from 'pco-product-service-internal-consumer';

export const getMemberCode = async (partnerNumber: string): Promise<MemberCodeOutput> => {
  return await memberZoneApi.getMemberCode({ partnerUid: partnerNumber });
};
